import { v4 as uuidv4 } from 'uuid';
import ProjectImg from '../images/projectImg.png';
import UTrackerImg from '../images/utracker.jpg';
import GreenCtgImg from '../images/greenctg.jpg';
import CoinTrackerImg from '../images/cointracker.jpg';
import CavinImg from '../images/cavinimg.jpg';

const projects = [
  {
    id: uuidv4(),
    name: 'AI Verifica',
    desc:
      'Made a Photo Verification System which will identify if the image uploaded is acceptable in important docs, like PAN card and Voter IDs',
    img: UTrackerImg,
  },
  {
    id: uuidv4(),
    name: 'AI Virtual Hand',
    desc:
      'Made a Virtual hand Volume and Brightness Controller, Virtual TouchPad using hand gesture with the help of OpenCV',
    img: GreenCtgImg,
  },
  {
    id: uuidv4(),
    name: 'Breast Cancer Prediction And Classification',
    desc:
      'Used both machine learning and deep learning approach to predict Breast Cancer',
    img: CoinTrackerImg,
  },
  {
    id: uuidv4(),
    name: 'Movie Recommender',
    desc:
      'A Content Based Movie Recommender System. Tools used were : Python , Machine Learning, React, Flask, HTML, CSS, Javascript',
    img: CavinImg,
  },
  {
    id: uuidv4(),
    name: 'Social Distancing Alert',
    desc:
      'Used Object Detection, Objection Tracking and Measurement to detect persons violating the Social Distancing Protocols',
    img: ProjectImg,
  },
];

export default projects;
